module.exports = __webpack_public_path__ + "img/testimonial-who-1.63581ec.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/testimonial-who-1.png
// module id = ./assets/img/testimonial-who-1.png
// module chunks = 2 3 4 5 6